import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import FoodcompositionFilterCriteria from './FoodcompositionFilterCriteria'
import FoodcompositionList from './FoodcompositionList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './FoodcompositionAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setFoodcompositionDashboardFoodcompositionList } from '../../store/slice/PharmaSlice';

export default function FoodcompositionListView({setShowEdit,setFoodcompositionId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.foodcompositionDashboard);   

    const [filteredFoodcompositionList, setFilteredFoodcompositionList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { foodcompositionDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (foodcompositionDashboard.foodcompositionList.length>-1){
        setFilteredFoodcompositionList(foodcompositionDashboard.foodcompositionList);
        transformToCardFormat(foodcompositionDashboard.foodcompositionList, setCardList);
      }
    },[foodcompositionDashboard.foodcompositionList])

    useEffect(()=>{
          transformToCardFormat(filteredFoodcompositionList, setCardList);
      },[filteredFoodcompositionList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredFoodcompositionList(foodcompositionDashboard.foodcompositionList);
            transformToCardFormat(foodcompositionDashboard.foodcompositionList, setCardList);

        } else {
            setFilteredFoodcompositionList(
                foodcompositionDashboard.foodcompositionList
                    .filter(foodcomposition=> foodcomposition.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(foodcompositionDashboard.filteredFoodcompositionList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <FoodcompositionList
                    setShowEdit={setShowEdit}
                    setFoodcompositionId = {setFoodcompositionId}
                    tableList={filteredFoodcompositionList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}